// import React, { useState } from 'react';
// import axios from 'axios';

// function Forgot() {
//   const [email, setEmail] = useState('');

//   const handleResetPassword = async () => {
//     if (!email) {
//       alert('Please enter your email.');
//       return;
//     }

//     try {
//       const response = await axios.post('http://localhost:4000/api/auth/forgot-password', {
//         email,
//       });

//       if (response.status === 200) {
//         alert('Reset link sent to your email!');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Failed to send reset link.');
//     }
//   };

//   return (
//     <div>
//       <br />
//       <h3 style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "20px", color: "#303030", marginLeft: "10px" }}>
//         <span>FORGOT YOUR PASSWORD?</span>
//       </h3>
//       <br />
//       <div className="field note" style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "14px", marginLeft: "10px" }}>
//         Please enter your email address below to receive a password reset link.
//       </div>
//       <br />
//       <div style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "14px", marginLeft: "10px", fontWeight: "bold" }}>
//         <label className="label" htmlFor="email"><span>Email</span></label>
//       </div>
//       <br />
//       <div className="control" style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "14px", marginLeft: "10px" }}>
//         <input
//           style={{ height: "45px", width: "475px" }}
//           id="email"
//           type="email"
//           className="input-text"
//           title="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//       </div>
//       <br />
//       <div style={{ textAlign: "left", marginLeft: "10px" }}>
//         <button  onClick={handleResetPassword} className="bt" style={{ fontFamily: "Alata,sans-serif", fontSize: "14px" }}>
//           <span>RESET MY PASSWORD</span>
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Forgot;

import React, { useState } from 'react';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleForgotPassword = async () => {
    try {
      const response = await fetch('http://localhost:4000/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage('Password reset email sent successfully!');
      } else {
        setMessage(`Error: ${data.message}`);
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('Failed to send password reset email. Please try again later.');
    }
  };

  return (
    <div>
          <br />
          <h3 style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "20px", color: "#303030", marginLeft: "10px" }}>
            <span>FORGOT YOUR PASSWORD?</span>
          </h3>
          <br />
          <div className="field note" style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "14px", marginLeft: "10px" }}>
            Please enter your email address below to receive a password reset link.
          </div>
          <br />
          <div style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "14px", marginLeft: "10px", fontWeight: "bold" }}>
            <label className="label" htmlFor="email"><span>Email</span></label>
          </div>
          <br />
          <div className="control" style={{ textAlign: "left", fontFamily: "Alata,sans-serif", fontSize: "14px", marginLeft: "10px" }}>
            <input
              style={{ height: "45px", width: "475px" }}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <br />
          <div style={{ textAlign: "left", marginLeft: "10px" }}>
            <button  onClick={handleForgotPassword}  className="bt" style={{ fontFamily: "Alata,sans-serif", fontSize: "14px" }}>
              <span>RESET MY PASSWORD</span>
            </button>
            {message && <p>{message}</p>}

          </div>
        </div>
  );
}

export default ForgotPassword;



